import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';
import { GetDpCardPromotions } from 'integration/generated/transactions/data-contracts';

export class DpCardPromotions<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	findDpCardPromotions = (
		storeId: string,
		query?: {
			orderId?: string;
		},
		data?: GetDpCardPromotions,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('findDpCardPromotions'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: {},
				methodName: 'findDpCardPromotions',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}

		return this.http.request<
			{
				promotions: {
					minAmount: string;
					installments: string;
					description: string;
					promoCode: string;
				}[];
			},
			void
		>({
			path: `/store/${storeId}/promotions/dpcard`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
